define('TescoMobile_Checkout/js/view/cart/order-cancelled',['uiComponent', '../../model/cancelled-order-processor'], function (Component, cancelledOrderProcessor) {
  'use strict';

  return Component.extend({
    defaults: {
      template: 'TescoMobile_Checkout/cart/order-cancelled',
      message: null
    },
    initObservable: function () {
      return this._super().observe(['message']);
    },
    initialize: function () {
      this._super();
      this.isOrderCancelled();
    },
    isOrderCancelled: function () {
      if (cancelledOrderProcessor.getMessage()) {
        this.message(cancelledOrderProcessor.getMessage());
        cancelledOrderProcessor.clearMessage();
      }
    }
  });
});

